import { render, staticRenderFns } from "./BuildingMap.vue?vue&type=template&id=3ee49d3e&scoped=true&"
import script from "./BuildingMap.vue?vue&type=script&lang=js&"
export * from "./BuildingMap.vue?vue&type=script&lang=js&"
import style0 from "./BuildingMap.vue?vue&type=style&index=0&id=3ee49d3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee49d3e",
  null
  
)

export default component.exports